'use client';
import React, { Fragment, useEffect, useState } from 'react';
import style from './ServicesNavMenu.module.scss';
import { menuItems } from '@/constants';
import { cn } from '@/lib/utils';
import { Icons } from '@/components/icons';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { getBookAppointmentUrl } from '@/lib/bookAppointment';

interface ServiceNavItem {
  label: string;
  path?: string;
  children?: ServiceNavItem[];
}

const serviceNavItems =
  menuItems.find((item) => item.path === '/services')?.children ?? [];

export const ServicesNavMenu = () => {
  const pathname = usePathname();
  const bookAppointmentUrl = getBookAppointmentUrl(pathname);

  const [openItem, setOpenItem] = useState<string | null>(null);

  useEffect(() => {
    setOpenItem(null);
  }, [pathname]);
  const toggleSubMenu = (path: string) => {
    setOpenItem(openItem === path ? null : path);
  };
  const isItemActive = (item: ServiceNavItem): boolean => {
    if (
      item.path &&
      (pathname === item.path || pathname.startsWith(`${item.path}/`))
    ) {
      return true;
    }

    if (item.children) {
      return item.children.some((child: ServiceNavItem) => isItemActive(child));
    }
    return false;
  };

  return (
    <ul className={style.contaner}>
      {serviceNavItems.map((item) => (
        <Fragment key={item.path}>
          <li
            onClick={() => toggleSubMenu(item.path)}
            className={cn(style.item, 'text-left text-white')}
          >
            <Link
              href={item.path || '#'}
              className={cn(
                'text-left',
                isItemActive(item) ? 'text-black' : 'text-white'
              )}
            >
              {item.label}
            </Link>
            {!!item?.children?.length && (
              <div className={style.iconWrapper}>
                {
                  <Icons.doubleArrow
                    rotate={openItem === item.path ? '90' : '0'}
                  />
                }
              </div>
            )}
          </li>
          {item?.children?.length && (
            <ul
              className={cn(
                style.subMenu,
                openItem === item.path ? style.open : style.closed
              )}
            >
              {item.children.map((subItem) => (
                <li
                  key={subItem.path}
                  className={cn(
                    style.subMenuItem,
                    'text-left text-white',
                    isItemActive(subItem) ? 'bg-black' : 'bg-[#4f4f4f]'
                  )}
                >
                  <Link href={subItem.path || '#'} className={` text-left`}>
                    {subItem.label}
                  </Link>
                  {/* <span>{subItem.label}</span> */}
                </li>
              ))}
            </ul>
          )}
        </Fragment>
      ))}
      <li className={style.bookCta}>
        <a
          href={bookAppointmentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={style.bookLink}
          aria-label="Book a service, opens our online scheduler in a new tab"
        >
          Book a Service
        </a>
      </li>
    </ul>
  );
};
